import { jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect, useContext } from "react";
import { TAB_INDEX_NEVER_FOCUSABLE } from "./Types.js";
const ActiveMenuItemContext = createContext(null);
function useActiveMenuItemContext() {
  return useContext(ActiveMenuItemContext);
}
function ActiveMenuItemProvider({
  children,
  menuRef
}) {
  const [element, setElement] = useState(null);
  useEffect(() => {
    if (!menuRef.current) {
      return;
    }
    const menu = menuRef.current;
    function changeActiveElement(event) {
      let focusedElement = event.target;
      while (focusedElement && !(focusedElement instanceof HTMLLIElement || focusedElement === menu)) {
        focusedElement = focusedElement.parentElement;
      }
      setElement(focusedElement instanceof HTMLLIElement && focusedElement.tabIndex > TAB_INDEX_NEVER_FOCUSABLE ? focusedElement : null);
    }
    menu.addEventListener("focus", changeActiveElement, { capture: true, passive: true });
    return () => {
      menu.removeEventListener("focus", changeActiveElement, { capture: true });
    };
  }, [element, menuRef]);
  return /* @__PURE__ */ jsx(ActiveMenuItemContext.Provider, { value: element, children });
}
export {
  ActiveMenuItemProvider,
  useActiveMenuItemContext
};
//# sourceMappingURL=useActiveMenuItem.js.map
